import ModalIncrement from './ModalIncrement'

export default ModalIncrement
